// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from "swiper/bundle";

import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./gallery.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const gallery = () => {
    let allGallery = document.querySelectorAll(".gallery");

    if (!allGallery.length) return;

    allGallery.forEach((el, i) => {
        lightGallery(el.querySelector(".lightgallery"), {
            selector: ".gallery__el",
            thumbnail: true,
            plugins: [lgThumbnail],
            exThumbImage: "data-exthumbimage",
            animateThumb: true,
            mobileSettings: {
                showCloseIcon: true,
            },
            download: false,
            hideBarsDelay: 1000000000,
            autoplayControls: false,
            hash: false,
            escKey: true,
            keyPress: true,
            licenseKey: "WQ63Z-598QW-NZ7D5-WPMTB",
        });
    });
};

export default gallery;
//--------------------------------------------------------------------//
